// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.norms-box {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 110px;
}

.norms-label {
  font-size: 12px;
  color: #1f252b;
  line-height: 1.2;
}

.norms-track {
  width: 72px;
  height: 9px;
  border-radius: 8px;
  background: #e2e8ec;
  overflow: hidden;
}

.norms-fill {
  height: 100%;
  background: #2cab2f;
  border-radius: 8px;
}

.norms-fill.low {
  background: #1850a7;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
